import { render, staticRenderFns } from "./ProductModalPrice.vue?vue&type=template&id=48aec352&"
import script from "./ProductModalPrice.vue?vue&type=script&lang=js&"
export * from "./ProductModalPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports